import React, { RefObject, createRef } from 'react';
import './Button.scss';
import './Button-media.scss';

import {Link} from "../Link/Link";

export interface Props {
  text?: string;
  size?: 'S' | 'M' | 'M-small' | 'L';
  type?: 'border' | 'black' | 'disabled' | 'link' | null;
  color?: 'white' | 'black';
  link?: string;
  widthAll?: boolean;
  onClick?: any;
  colorText?: 'dark';
  disabled?: boolean;
  title?: string;
  linkOut?: boolean;
  icon?: boolean;
}

const Button = ({
  text,
  size,
  type,
  color,
  link,
  widthAll,
  onClick,
  colorText,
  disabled,
  title,
  linkOut = false,
  icon,
}: Props) => {
  const elLink: RefObject<HTMLAnchorElement> = createRef();
  const elButton: RefObject<HTMLButtonElement> = createRef();
  const elSpan: RefObject<HTMLSpanElement> = createRef();

  const className =
    'button' +
    `${size ? ` button_${size}` : ' button_L'}` +
    `${type ? ` button_type-${type}` : ''}` +
    `${widthAll ? ` button_width-all` : ''}` +
    `${colorText ? ` button_text-${colorText}` : ''}` +
    `${disabled ? ` button_disabled` : ''}` +
    `${icon ? ` button_icon` : ''}` +
    `${color ? ` button_${color}` : ''}`;

  if (linkOut) {
    return (
      <a
        href={link}
        className={className}
        onClick={onClick}
        target="_blank"
        rel="nofollow"
        ref={elLink}
        onMouseEnter={HoverButton(elLink, elSpan)}
        onMouseOut={HoverButton(elLink, elSpan)}
      >
        {text}
        <span ref={elSpan}></span>
      </a>
    );
  }

  return link ? (
    <Link
      to={link}
      className={className}
      onClick={onClick}
      ref={elLink}
      onMouseEnter={HoverButton(elLink, elSpan)}
      onMouseOut={HoverButton(elLink, elSpan)}
    >
      {text}
      <span ref={elSpan}></span>
    </Link>
  ) : (
    <>
      <button
        type="submit"
        className={className}
        onClick={onClick}
        disabled={disabled}
        title={title}
        ref={elButton}
        onMouseEnter={HoverButton(elButton, elSpan)}
        onMouseOut={HoverButton(elButton, elSpan)}
      >
        {text}
        <span ref={elSpan}></span>
      </button>
    </>
  );
};

export default Button;

const processButtonHoverCoordinates = (e: any, button?: any, span?: any) => {
  let Top = button?.getBoundingClientRect().top;
  let Left = button?.getBoundingClientRect().left;

  if (Top && Left) {
    let relX = e.clientX - Left;
    let relY = e.clientY - Top;
    span.style.top = `${relY}px`;
    span.style.left = `${relX}px`;
  }
}

export const HoverButtonNative = (button?: any, span?: any) => (e: any) => {
  processButtonHoverCoordinates(e, button, span);
}

export const HoverButton = (button: RefObject<any>, span: RefObject<any>) => (e: any) => {
  processButtonHoverCoordinates(e, button.current, span.current);
};
